// extracted by mini-css-extract-plugin
export default {"actionWrap":"StudentBillings_actionWrap__eavQA","subheader":"StudentBillings_subheader__3wDYN","checkbox":"StudentBillings_checkbox__uhzZk","active":"StudentBillings_active__-Oo99"};